import React from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { ChangeSaleDrawer } from "./details/changeSaleDrawer";
import { PoPrint } from "./PoPrint"
export default () => {
    return (
        <>
            <PageHeader />
            <DataBox />
            <ChangeSaleDrawer />
            <PoPrint/>
        </>
    )
}